import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [roleView, setRoleViewState] = useState(() => localStorage.getItem("empro_view") || "admin");

  const setRoleView = (v) => { localStorage.setItem("empro_view", v); setRoleViewState(v); };

  useEffect(() => {
    const t = localStorage.getItem("empro_token");
    if (!t) { setLoading(false); return; }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(null)).finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    const h = () => setUser(null);
    window.addEventListener("empro-logout", h);
    return () => window.removeEventListener("empro-logout", h);
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("empro_token", data.token);
    setRoleView("admin");
    setUser(data.user);
    return data.user;
  };
  const changePassword = async (new_password) => {
    await api.post("/auth/change-password", { new_password });
    setUser((u) => ({ ...u, must_change_pin: false }));
  };
  const logout = () => { localStorage.removeItem("empro_token"); localStorage.removeItem("empro_view"); setUser(null); };

  return <Ctx.Provider value={{ user, loading, login, logout, changePassword, roleView, setRoleView }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
